<template>
    <div class="notice-detail-page">
        <!-- 顶部信息 -->
        <div class="page-header">
            <div class="header-info">
                <span class="info-item">
                    <span class="label">招标项目名称：</span>
                    <span class="value">{{ projectName }}</span>
                </span>
                <span class="divider"></span>
                <span class="info-item">
                    <span class="label">招标项目编号：</span>
                    <span class="value">{{ projectCode }}</span>
                </span>
            </div>
        </div>

        <!-- 详情内容 -->
        <div class="content-container">
            <div class="section-header">
                <span class="section-title">中标候选人公示信息</span>
            </div>

            <div class="detail-table">
                <div class="detail-row">
                    <span class="detail-label">公示标题</span>
                    <span class="detail-value">{{ form.winCandidateBulletinName || '--' }}</span>
                </div>
                <div class="detail-row">
                    <span class="detail-label">关联标段</span>
                    <span class="detail-value">{{ sectionNames || '--' }}</span>
                </div>
                <div class="detail-row">
                    <span class="detail-label">公示开始时间</span>
                    <span class="detail-value">{{ form.startTime || '--' }}</span>
                </div>
                <div class="detail-row">
                    <span class="detail-label">公示结束时间</span>
                    <span class="detail-value">{{ form.endTime || '--' }}</span>
                </div>
                <div class="detail-row">
                    <span class="detail-label">公示发布时间</span>
                    <span class="detail-value">{{ form.publicTime || '--' }}</span>
                </div>
                <div class="detail-row">
                    <span class="detail-label">公示性质</span>
                    <span class="detail-value">{{ typeCodeText(form.typeCode) }}</span>
                </div>
            </div>

            <!-- 公示正文 -->
            <div class="content-block">
                <div class="content-block-title">公示正文</div>
                <div class="content-block-body" v-if="form.winCandidateBulletinContent" v-html="form.winCandidateBulletinContent"></div>
                <div class="content-block-body content-block-body--empty" v-else>暂无正文</div>
            </div>

            <!-- 附件 -->
            <div class="content-block" style="margin-top: 20px;">
                <div class="content-block-title">附件</div>
                <div class="content-block-body" v-if="attachFileList && attachFileList.length > 0" style="padding: 16px 20px; min-height: auto;">
                    <div class="attach-item" v-for="(file, fIndex) in attachFileList" :key="fIndex">
                        <span class="attach-item-name">{{ file.name }}</span>
                        <el-button type="text" size="small" @click="handleDownload(file)">下载</el-button>
                    </div>
                </div>
                <div class="content-block-body content-block-body--empty" v-else style="min-height: 80px;">暂无附件</div>
            </div>

            <!-- 底部按钮 -->
            <div class="form-footer">
                <el-button @click="handleBack">返回</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { Api_GetWinCandidateBulletinDetail } from '@/api/modules/semiProcess'
import { getFileList } from '@/api/modules/base'

export default {
    name: 'CandidatePublicityDetail',

    data() {
        return {
            projectName: '',
            projectCode: '',
            fileGuid: '',
            sectionList: [],
            attachFileList: [],
            form: {
                winCandidateBulletinName: '',
                startTime: '',
                endTime: '',
                publicTime: '',
                winCandidateBulletinContent: '',
                typeCode: ''
            }
        }
    },

    computed: {
        sectionNames() {
            return this.sectionList.map(s => s.bidSectionName).join('、')
        }
    },

    created() {
        this.projectName = this.$route.query.projectName || ''
        this.projectCode = this.$route.query.projectCode || ''
        this.getDetail()
    },

    methods: {
        typeCodeText(typeCode) {
            const map = { 1: '正常公示', 2: '更正公示' }
            return map[typeCode] || '-'
        },

        getDetail() {
            const winCandidateBulletinCode = this.$route.query.winCandidateBulletinCode
            if (!winCandidateBulletinCode) {
                this.$message.error('缺少公示编号参数')
                return
            }
            Api_GetWinCandidateBulletinDetail({
                projectCode: this.projectCode,
                winCandidateBulletinCode: winCandidateBulletinCode
            }).then(res => {
                if (res.code === 200 && res.data) {
                    const data = res.data
                    this.form.winCandidateBulletinName = data.winCandidateBulletinName || ''
                    this.form.startTime = data.startTime || ''
                    this.form.endTime = data.endTime || ''
                    this.form.publicTime = data.publicTime || ''
                    this.form.winCandidateBulletinContent = data.winCandidateBulletinContent || ''
                    this.form.typeCode = data.typeCode
                    this.sectionList = data.sections || []
                    this.fileGuid = data.fileGuid || ''
                    if (data.fileGuid) {
                        this.getAttachFileList(data.fileGuid)
                    }
                }
            }).catch(() => {
                this.$message.error('获取详情失败')
            })
        },

        getAttachFileList(fileGuid) {
            getFileList(fileGuid).then(res => {
                if (res.code === 200 && res.data) {
                    this.attachFileList = (res.data || []).map(file => ({
                        name: file.fileName || file.name || '附件',
                        fileUrl: file.fileUrl || '',
                        fileSize: file.fileSize || 0,
                        fileId: file.fileId || ''
                    }))
                }
            }).catch(() => {
                this.attachFileList = []
            })
        },

        handleDownload(file) {
            if (file.fileUrl) {
                window.open(file.fileUrl, '_blank')
            } else {
                this.$message.warning('文件链接不存在')
            }
        },

        handleBack() {
            this.$router.back()
        }
    }
}
</script>

<style lang="less" scoped>
.notice-detail-page {
    background: #f5f5f5;
    min-height: 100vh;
    padding: 20px;
}

.page-header {
    background: #fff;
    padding: 16px 20px;
    margin-bottom: 12px;
}

.header-info {
    display: flex;
    align-items: center;
}

.info-item {
    font-size: 14px;
}

.label {
    color: #666;
}

.value {
    color: #333;
}

.divider {
    width: 1px;
    height: 14px;
    background: #ddd;
    margin: 0 20px;
}

.content-container {
    background: #fff;
    padding: 20px;
}

.section-header {
    padding-bottom: 16px;
    margin-bottom: 20px;
    border-bottom: 1px solid #eee;
}

.section-title {
    font-size: 15px;
    font-weight: 500;
    color: #333;
}

.detail-table {
    border: 1px solid #ebeef5;
    border-radius: 4px;
    overflow: hidden;
    margin-bottom: 20px;
}

.detail-row {
    display: flex;
    border-bottom: 1px solid #ebeef5;

    &:last-child {
        border-bottom: none;
    }
}

.detail-label {
    width: 160px;
    min-width: 160px;
    padding: 14px 16px;
    background: #fafafa;
    color: #606266;
    font-size: 14px;
    font-weight: 500;
    display: flex;
    align-items: flex-start;
    border-right: 1px solid #ebeef5;
    box-sizing: border-box;
}

.detail-value {
    flex: 1;
    padding: 14px 16px;
    color: #303133;
    font-size: 14px;
    word-break: break-all;
    display: flex;
    align-items: flex-start;
}

.content-block {
    border: 1px solid #ebeef5;
    border-radius: 4px;
    overflow: hidden;
}

.content-block-title {
    padding: 14px 20px;
    background: #fafafa;
    color: #606266;
    font-size: 14px;
    font-weight: 500;
    border-bottom: 1px solid #ebeef5;
}

.content-block-body {
    padding: 24px 28px;
    color: #303133;
    font-size: 15px;
    line-height: 2;
    min-height: 200px;
    word-break: break-all;

    &--empty {
        display: flex;
        align-items: center;
        justify-content: center;
        color: #c0c4cc;
    }

    /deep/ p {
        margin: 0 0 12px;

        &:last-child {
            margin-bottom: 0;
        }
    }
}

.attach-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
    border-bottom: 1px dashed #ebeef5;

    &:last-child {
        border-bottom: none;
        padding-bottom: 0;
    }

    &:first-child {
        padding-top: 0;
    }
}

.attach-item-name {
    flex: 1;
    color: #303133;
    font-size: 14px;
    word-break: break-all;
}

.form-footer {
    padding-top: 24px;
    margin-top: 24px;
    border-top: 1px solid #eee;
    display: flex;
    justify-content: center;
    gap: 12px;
}
</style>
